// extracted by mini-css-extract-plugin
export default {"owner":"tFbTE","heading":"b9BEp","owner-info":"Tx94M","owner-raising-for":"lvXh1","name":"sPcQN","avatar":"p9UYV"};